import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import overachieversReportComponent from './overachievers-report.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let overachieversReportModule = angular.module('overachievers', [
  uiRouter,
  modal,
  datepickerPopup
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
  $urlRouterProvider.otherwise('/');

  $stateProvider.state('overachievers', {
    parent: 'app',
    url: '/admin/reports/overachievers',
    data: {
      pageHeader: true,
      pageTitle: 'Overachievers Report',
      pageDesc: '',
      breadcrumbLink: 'admin.reports',
      breadcrumbText: 'View All Reports'
    },
    template: '<overachievers></overachievers>'
  });

})

.component('overachievers', overachieversReportComponent);

export default overachieversReportModule;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/overachievers-report/overachievers-report.js